import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import HideImageOutlinedIcon from "@mui/icons-material/HideImageOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import StorageIcon from "@mui/icons-material/Storage";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import { useEffect, useState } from "react";
import {
  Menu,
  MenuItem,
  Sidebar,
  SubMenu
} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import logo from "./Group 466.svg";
import "./Sidebar.css";
import CarplImg from "./carpl_logo.svg";
import DnDFlow from "../WorkflowComponents/ReactRendererFlow";
function SideBar() {
  const [isSidebarOpen, setisSidebarOpen] = useState(false);
  const [version, setVersion] = useState("");
  const styles = {
    sideBarStyle: {
      height: "100vh",
      position: "fixed",
      zIndex: 101,
      border: "none",
    },
  };

  const sidebartext = { fontFamily: "Montserrat" };

  useEffect(() => {
    let version = localStorage.getItem("version");
    setVersion(version);
  }, []);

  return (
    <div className="heightSide">
      <Sidebar
        collapsed={!isSidebarOpen}
        onMouseEnter={() => setisSidebarOpen(true)}
        onMouseLeave={() => setisSidebarOpen(false)}
        style={styles.sideBarStyle}>
        <Menu style={{ width: "100%" }}>
          <MenuItem style={{ cursor: "text" }}>
            {!isSidebarOpen && (
              <img src={logo} style={{ padding: "10px" }} alt="logo"></img>
            )}
            <img src={CarplImg} alt="carpl"></img>
          </MenuItem>
          <MenuItem icon={<DashboardIcon />} component={<Link to="/home" />}>
            <span style={sidebartext}>Dashboard</span>
          </MenuItem>
          <SubMenu
            icon={<SettingsIcon />}
            label="Configure"
            style={sidebartext}
            defaultOpen={true}>
            <MenuItem
              icon={<StorageIcon />}
              component={<Link to="/pacsdata" />}>
              <span style={sidebartext}> PACS</span>
            </MenuItem>
            {/* <MenuItem
              icon={<StorageIcon />}
              component={
                <Link
                  to="/flow/:id"
                />
              }
            >
              <span style={sidebartext}> REACTFLOW</span>
            </MenuItem> */}
            <MenuItem
              icon={<AutoAwesomeMosaicOutlinedIcon />}
              component={<Link to="/Pacsconfig" />}>
              <span style={sidebartext}>PACS Config</span>
            </MenuItem>
            <MenuItem
              icon={<FilterAltOutlinedIcon />}
              component={<Link to="/filterdata" />}>
              <span style={sidebartext}>Filter</span>
            </MenuItem>
            <MenuItem
              icon={<UploadOutlinedIcon />}
              component={<Link to="/platformdata" />}>
              <span style={sidebartext}> Platform</span>
            </MenuItem>
            <MenuItem
              icon={<HideImageOutlinedIcon />}
              component={<Link to="/protocoldata" />}>
              <span style={sidebartext}> Anon Protocol</span>
            </MenuItem>
            <MenuItem
              icon={<SettingsOutlinedIcon />}
              component={<Link to="/configure" />}>
              <span style={sidebartext}> Router Config</span>
            </MenuItem>
            <MenuItem
              icon={<GetAppOutlinedIcon />}
              component={<Link to="/fetchData" />}>
              <span style={sidebartext}>QR Studies</span>
            </MenuItem>
            <MenuItem
              icon={<StorageIcon />}
              component={<Link to="/Hl7Nodes" />}>
              <span style={sidebartext}>HL7 Nodes</span>
            </MenuItem>
            <MenuItem
              icon={<AutoAwesomeMosaicOutlinedIcon />}
              component={<Link to="/Hl7Config" />}>
              <span style={sidebartext}>HL7 Config</span>
            </MenuItem>
          </SubMenu>
        </Menu>

        {isSidebarOpen && (
          <div className="version-class">
            <div className="version-title">Version:</div>
            <div className="version-number">{version}</div>
          </div>
        )}
      </Sidebar>
    </div>
  );
}

export default SideBar;
